<template>
  <div>
    <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
      <tags-input
        element-id="tags"
        v-model="selectedTags"
        :existing-tags="tags"
        :only-existing-tags="true"
        @tag-added="onTagAdded"
        @tag-removed="onTagRemoved"
        placeholder="Добавить объект"
        :typeahead="true"
        :disabled="$parent.$parent.projectDisabled"
      ></tags-input>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  name: "HighTechList",
  data() {
    return {
      selectedTags: [],
      tagsLoaded: false
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["high_tehnology_sp"]).then(() => {
      this.project.UF_HIGH_TECH_LIST_ID.forEach(function(cId) {
        this.directory.high_tehnology_sp.forEach(function(c) {
          if (cId === c.ID) {
            this.selectedTags.push(c.NAME);
          }
        }, this);
      }, this);
      this.tagsLoaded = true;
    }, this);
  },
  methods: {
    onTagAdded(slug) {
      if (slug >= 0) {
        this.project.UF_HIGH_TECH_LIST_ID.push(
          this.directory.high_tehnology_sp[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      if (slug.length > 8) {
        this.directory.high_tehnology_sp.forEach(function(c) {
          if (c.NAME === slug) {
            rem = c.ID;
          }
        });
      } else {
        let onTagRemovedName = this.directory.high_tehnology_sp[slug].NAME;
        this.directory.high_tehnology_sp.forEach(function(c) {
          if (c.NAME === onTagRemovedName) {
            rem = c.ID;
          }
        });
      }
      if (rem > 0) {
        this.project.UF_HIGH_TECH_LIST_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_HIGH_TECH_LIST_ID.splice(index, 1);
          }
        }, this);
      }
    }
  },
  computed: {
    tags() {
      let tags = {};
      this.directory.high_tehnology_sp.forEach(function(el, k) {
        tags[k] = el.NAME;
      }, this);
      return tags;
    },
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
